import styled from 'styled-components';

export const HistoryStepperSC = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    background: none;
    border: none;
    outline: none;
    box-shadow: none;
  }
  .back {
    width: 36px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 0px;
    cursor: pointer;
  }
  .center {
    font-size: 14px;
    font-weight: 700;
  }
  .next {
    width: 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 5px 0px;
    cursor: pointer;
    &.disabled {
      opacity: 0.5;
    }

    svg {
      transform: rotateZ(180deg);
    }
  }
  svg {
    width: 8px;
  }
`;
